<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <div class="filter-forms-nav pages-title-nav p-0">
      <div class="container-fluid px-4">
        <div class="row align-items-center">
          <div class="sample-details-title col-xs-12 col-sm-12 col-md-12 col-12 nav-colmn pl-0 ">
            <ul class="page-name-div sample-name-list d-flex align-items-center">
              <a class="left-arrow " href="/dashboard/samples">
                <span class="material-symbols-outlined purple-text pt-1 ">chevron_left</span>
              </a>
              <app-tab-main [links]="tabs"></app-tab-main>
              <span class="ml-auto d-flex align-items-center">
                <span class="ml-2">
                  {{ 'Sample No' | translate }}: <b>{{ sampleData?.sampleNumber }}</b>
                </span>
              </span>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="page-content-inner-wrap card-style-sec sample-result-page-wrap custom-scrollbar">
      <div class="container-fluid">

        <!-- ═══════════════════════════════════════════ -->
        <!-- RESULTS & COMPLIANCE — full width             -->
        <!-- ═══════════════════════════════════════════ -->
        @if (sampleData?.ihLabResults?.length) {
          <div class="results-section">
            <h3 class="section-title">
              <img src="assets/images/agents.svg" class="mr-1">
              {{ 'Results & Compliance' | translate }}
              <button class="results-edit-btn"
                [disabled]="isNonEditableStatus"
                (click)="openLabResultsDialog()">
                <span class="material-symbols-outlined">edit</span>
                {{ 'Edit Results' | translate }}
              </button>
            </h3>
            <div class="section">
              @if (hasBlankCorrectionApplied) {
                <div class="blank-correction-tag">
                  <span class="blank-correction-badge">{{ 'Blank Correction Applied' | translate }}</span>            </div>
                }
                <app-gravimetric-results class="w-100" [iHLabResults]="$safeNavigationMigration(sampleData?.ihLabResults)"
                  [isSampleTypeNoise]="sampleData?.sampleType === sampleTypeEnum.Noise"
                  [showNoiseDoseComparison]="false">
                </app-gravimetric-results>
              </div>
            </div>
          }
          @if (sampleData && !sampleData?.ihLabResults?.length) {
            <div class="results-empty-bar">
              <img src="assets/images/agents.svg" class="results-empty-icon">
              <span class="results-empty-text">{{ 'No results available' | translate }}</span>
              <button class="results-add-btn" [disabled]="isNonEditableStatus" (click)="openLabResultsDialog()">
                <span class="material-symbols-outlined">add</span>
                {{ 'Add Results' | translate }}
              </button>
            </div>
          }

          <!-- ═══════════════════════════════════════════ -->
          <!-- GRAPH + SIDEBAR — 8/4 split                 -->
          <!-- ═══════════════════════════════════════════ -->
          <div class="row">
            <div class="col-md-8">
              <section class="card-style-sec inner-page-card-sec pt-0">
                <app-exposure-graph class="graph-height" [selectedTab]="selectedTab" [loadCommentsAndNotes]="loadCommentsAndNotes"
                  [isVideoChartHidden]="isVideoChartHidden" [CHART_VIDEO_DIV_ID]="CHART_VIDEO_DIV_ID"
                  [showChartFilter]="showChartFilter" [chart]="chart" [CHART_DIV_ID]="CHART_DIV_ID"
                  [taskRangeVisibility]="taskRangeVisibility" [chartDetails]="chartDetails"
                  (clearCommentRangesEmit)="clearCommentRanges()" (toggleShowChartFilterEmit)="toggleShowChartFilter()"
                  (onResizedEmit)="onResizedFn($event)" (showNotesRangeEmit)="showNotesRangeFn($event)"
                  (showTaskRangeEmit)="showTaskRangeFn($event)" (hideChartFilterEmit)="hideChartFilterFn()"
                  (onVideoResizedEmit)="onVideoResized($event)" (showCumulativeLinesEmit)="showCumulativeLine()"
                  (showTrendLinesEmit)="showTrendLines()">
                  <ng-container header-actions>
                    @if (sampleData?.sensorAssignmentId) {
                      <span class="d-flex align-items-center">
                        <button class="edit-icon-btn mr-2" [attr.aria-label]="'Edit Sensor Assignment' | translate"
                          [title]="'Edit Sensor Assignment' | translate"
                          (click)="openNodeAssignmentDialog()">
                          <i class="material-icons material-grey-icon">edit</i>
                        </button>
                        <button mat-button [matMenuTriggerFor]="parameterMenu" class="sort-icon">
                          {{selectedParameter?.name}}
                          <i class="material-icons right">expand_more</i>
                        </button>
                        <mat-menu #parameterMenu="matMenu" xPosition="before" yPosition="below">
                          @for (risk of parameters; track trackById($index, risk)) {
                            <button mat-menu-item (click)="setAnalyte(risk)">
                              {{risk.name}}
                            </button>
                          }
                        </mat-menu>
                      </span>
                    }
                  </ng-container>
                </app-exposure-graph>
              </section>

              <section class="card-style-sec shift-exposures-table-sec">
                <app-exposure-contributions (sortExposureContributionsEmit)="sortExposureContributionsEmit($event)"
                  [taskAssignmentColumnsToDisplay]="taskAssignmentColumnsToDisplay"
                  [taskAssignmentDataSource]="taskAssignmentDataSource" [loadingAssessments]="loadingAssessments"
                  [taskColor]="taskColor" [taskSelectColor]="taskSelectColor"
                  [sensorAssignmentData]="sensorAssignmentData"
                  [taskAssignmentColumnsToDisplayStr]="taskAssignmentColumnsToDisplayStr"
                  [taskAssignmentColumnsToDisplayWithExpand]="taskAssignmentColumnsToDisplayWithExpand"
                  [taskAssignmentExposureExpandedElement]="taskAssignmentExposureExpandedElement"
                  [selectedTaskName]="selectedTaskName" [taskRangeVisibility]="taskRangeVisibility"
                  (showTaskRangeEmit)="showTaskRangeFn($event)" (clearTaskRangesEmit)="clearTaskRanges()"
                  (loadTaskAssignmentEmit)="reloadTaskAssignments()">
                </app-exposure-contributions>
              </section>
            </div>

            <div class="col-md-4">
            <ng-container *ngTemplateOutlet="attachmentSection;
                          context: { title: 'Lab Results', list: labAttachments, icon: 'assets/images/link.svg' }">
              </ng-container>
            <ng-container *ngTemplateOutlet="attachmentSection;
                          context: { title: 'Reports', list: reportAttachments, icon: 'assets/images/link.svg' }">
              </ng-container>
              <div class="pb-2"></div>
              <div class="d-none safety-equipments-section card-inner-main-div curved-section-shadow mt-2">
                <div class="equipments-breadcrumb">
                  <ul class="breadcrumb">
                    <li class="breadcrumb-item text-color-lighter text-semibold">{{ 'PPE Worn' | translate }}</li>
                    <li class="breadcrumb-item text-color-lighter text-semibold">{{ 'Respiratory' | translate }}</li>
                    <li class="breadcrumb-item text-color-lighter text-semibold">Versa Flo M-300</li>
                  </ul>
                </div>
                <div class="equipments-options-list">
                  <div class="d-flex align-items-center flex-wrap justify-content-center">
                    @for (item of safetyItemsList; track trackByIndex($index)) {
                      <div class="equipments-option">
                        <div class="option-img">
                          <img src="./assets/images/{{item.img}}.svg">
                        </div>
                        @if (item.isSelected) {
                          <img class="option-tick" src="assets/images/green-tick.svg">
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <section class="card-style-sec shift-exposures-table-sec  {{isVideoShow?'with-video':''}}">
                @if (isVideoShow && videoResource) {
                  <div class="row video-col video-wrap">
                    <div class="col-12">
                      <app-lazy-video-player [videoResource]="videoResource"
                        (onPlayerReadyEmit)="onPlayerReady($event)">
                      </app-lazy-video-player>
                    </div>
                  </div>
                }
                <div class="row exposures-table-comment-row">
                  <div class="col-12 border-left">
                    <app-comments-notes [loadCommentsAndNotes]="loadCommentsAndNotes" [comments]="comments"
                      [tasksAssignmentNotes]="tasksAssignmentNotes" [loadingAssessments]="loadingAssessments"
                      (updateGraphAndNotes)="sampleRecordInfo()" (showCommentRangeEmit)="showCommentRange($event)"
                    (showNoteRangeEmit)="showNoteRange($event)"></app-comments-notes>
                  </div>
                </div>
              </section>
            </div>
          </div>

        </div>
      </div>
    </app-sidebar-layout>
  </div>

  <ng-template #attachmentSection let-title="title" let-list="list" let-icon="icon">
    @if (list?.length) {
      <div class="col-md-12 two-col pt-2 px-0">
        <h3 class="section-title">
          <img [src]="icon || 'assets/images/link.svg'" class="mr-1">
          {{ title | translate }}
        </h3>
        <div class="section limit-section-height">
          <div class="field-container">
            <div class="field">
              <div class="field-value row">
                @for (attachment of list; track trackById($index, attachment)) {
                  <div class="col-md-12">
                    <div class="attachment-item d-flex justify-content-between align-items-center">
                      <span class="file-name d-flex align-items-center">
                        <img [src]="attachment.imgSrc || 'assets/images/file-note.svg'" class="mr-2">
                        {{ attachment.name }}
                      </span>
                      @if (attachment.emailStatus != null) {
                        <span class="email-status">
                          <i class="fa fa-envelope mx-1"></i>
                          {{emailStatusEnum[attachment.emailStatus] | translate}}
                          @if (attachment?.emailSentDate && attachment.emailStatus == emailStatusEnum.Sent) {
                            <span class="email-date">
                              {{ attachment.emailSentDate | dateFormat }}
                            </span>
                          }
                        </span>
                      }
                      <button mat-icon-button color="primary"
                        [attr.aria-label]="'Download ' + attachment.name"
                        (click)="downloadAttachment(attachment)">
                        <img src="assets/images/download.svg" alt="">
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </ng-template>
